import type { Configuration } from '@azure/msal-browser';

const clientId = window.PORTAL_MSAL_CLIENT_ID ?? import.meta.env.VITE_MSAL_CLIENT_ID;
const authority = `https://login.microsoftonline.com/${window.PORTAL_MSAL_TENANT_ID ?? import.meta.env.VITE_MSAL_TENANT_ID}`;
const redirectUri = window.PORTAL_MSAL_REDIRECT_URI ?? import.meta.env.VITE_MSAL_REDIRECT_URI;

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const loginRequest = {
  scopes: [window.PORTAL_MSAL_SCOPE ?? import.meta.env.VITE_MSAL_SCOPE],
};

export default msalConfig;
